/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable object-shorthand */
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import React, { useCallback, useContext } from 'react';
import { useLocation, withRouter } from 'react-router-dom';
import { useAuthentication, withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import './ContactUnderwriter.messages';
import _ from 'lodash';
import { BreakpointTrackerContext } from '@jutro/layout';
import metadata from './ContactUnderwriter.metadata.json5';

function ContactUnderwriter(props) {
    const { history, match } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const location = useLocation();
    const { policyNumber } = location?.state;
    const authUserData = _.get(useAuthentication(), 'authUserData');
    const isTFPA = authUserData?.associationName_TWIA === 'tfpa';

    // DE17535 If there are multiple policy changes redirect to contact-underwriter view
    const goToPolicy = useCallback(() => {
        const redirectLobPath = `/policies/${location?.state}/summary`;

        history.push(redirectLobPath);
    });

    const overrideProps = {
        '@field': {
            // apply to all fields
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
        },
        changePolicy: {
            visible: !isTFPA,
        },
        changePolicyTFPA: {
            visible: isTFPA,
        },
        changePolicyContactUnderwriter: {
            visible: !isTFPA,
        },
        changePolicyContactUnderwriterTFPA: {
            visible: isTFPA,
        },
        backToPolicyButtonId: { // DE18247
            content: !isTFPA ? 'Back to Policy' : 'Save and Exit'
        },
    };

    const resolvers = {
        resolveCallbackMap: {
            goToPolicy: goToPolicy,
        },
    };

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
            callbackMap={resolvers.resolveCallbackMap}
        />
    );
}

ContactUnderwriter.propTypes = wizardProps;
export default withRouter(ContactUnderwriter);
